import type { IconProp } from '@hover/icons';
import { iFacebook, iInstagram } from '@hover/icons';
import type { TFunction } from 'i18next';
import type { FunctionComponent, SVGProps } from 'react';

import type { TranslationNamespaceType } from 'src/i18n/types';
import { External } from 'src/shared/route';

export interface SocialLinkProps {
  color: string;
  icon: IconProp | FunctionComponent<SVGProps<SVGSVGElement>>;
  fill: string;
  label: string;
  path: string;
}

export const getSocialOptions = (
  t: TFunction<
    | 'designStudio'
    | 'ehi'
    | 'homeownerApp'
    | 'propertyDetails'
    | 'login'
    | 'notFound'
    | 'properties'
    | 'shared'
    | 'signUp'
    | 'newConstruction'
    | 'paintMeasurements'
    | 'somethingWrong'
    | 'virtualWalkthrough'
    | 'manageTeams'
    | TranslationNamespaceType[],
    undefined
  >,
): SocialLinkProps[] => [
  {
    label: t('social.instagram'),
    icon: iInstagram,
    path: External.SOCIAL_INSTAGRAM.path,
    color: 'inherit',
    fill: 'none',
  },
  {
    label: t('social.facebook'),
    icon: iFacebook,
    path: External.SOCIAL_FACEBOOK.path,
    color: 'transparent',
    fill: 'inherit',
  },
];
